var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getListToRender } from '../getListToRender';
import { getNewList } from './getNewList';
export var createReducer = function (_a) {
    var searchAttributes = _a.searchAttributes, dropdownList = _a.dropdownList, noMatchDropdownList = _a.noMatchDropdownList, maxRenderedDropdownElements = _a.maxRenderedDropdownElements, searchMatcher = _a.searchMatcher, isEqual = _a.isEqual;
    return function (state, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        switch (action.type) {
            case 'InputKeyDownEscape':
                return __assign(__assign({}, state), { noMatch: false, isExpanded: false, highlightedIndex: -1, inputValue: '' });
            case 'InputClick': {
                var _s = getListToRender({
                    inputValue: state.inputValue,
                    searchAttributes: searchAttributes,
                    maxRenderedDropdownElements: maxRenderedDropdownElements,
                    dropdownList: dropdownList,
                    noMatchDropdownList: noMatchDropdownList,
                    searchMatcher: searchMatcher,
                    showAllItemsInDropdown: true,
                }), noMatch = _s.noMatch, listToRender = _s.listToRender;
                return __assign(__assign({}, state), { isExpanded: true, listToRender: listToRender, noMatch: noMatch });
            }
            case 'RemoveItem': {
                if ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.items) {
                    return __assign(__assign({}, state), { highlightedIndex: -1, selectedItems: getNewList(state.selectedItems, action.payload.items, 'removed', isEqual), inputValue: '' });
                }
                return state;
            }
            case 'InputChange': {
                var _t = getListToRender({
                    inputValue: (_c = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.inputValue) !== null && _c !== void 0 ? _c : '',
                    searchAttributes: searchAttributes,
                    maxRenderedDropdownElements: maxRenderedDropdownElements,
                    dropdownList: dropdownList,
                    noMatchDropdownList: noMatchDropdownList,
                    searchMatcher: searchMatcher,
                    showAllItemsInDropdown: false,
                }), noMatch = _t.noMatch, listToRender = _t.listToRender;
                return __assign(__assign({}, state), { isExpanded: true, inputValue: (_e = (_d = action.payload) === null || _d === void 0 ? void 0 : _d.inputValue) !== null && _e !== void 0 ? _e : '', listToRender: listToRender, highlightedIndex: ((_g = (_f = action.payload) === null || _f === void 0 ? void 0 : _f.inputValue) === null || _g === void 0 ? void 0 : _g.trim()) === '' ||
                        listToRender.length === 0
                        ? -1
                        : 0, noMatch: noMatch });
            }
            case 'ToggleButtonPressed':
                return __assign(__assign({}, state), { isExpanded: !state.isExpanded });
            case 'ItemSelectedProgrammatically':
                if (((_h = action.payload) === null || _h === void 0 ? void 0 : _h.items) !== undefined) {
                    return __assign(__assign({}, state), { selectedItems: action.payload.items });
                }
                return state;
            case 'ItemOnClick':
            case 'InputKeyDownEnter':
                if ((_j = action.payload) === null || _j === void 0 ? void 0 : _j.items) {
                    var _u = getListToRender({
                        inputValue: '',
                        searchAttributes: searchAttributes,
                        maxRenderedDropdownElements: maxRenderedDropdownElements,
                        dropdownList: dropdownList,
                        noMatchDropdownList: noMatchDropdownList,
                        searchMatcher: searchMatcher,
                        showAllItemsInDropdown: true,
                    }), noMatch = _u.noMatch, listToRender = _u.listToRender;
                    return __assign(__assign({}, state), { isExpanded: true, highlightedIndex: state.inputValue.trim() === ''
                            ? ((_l = (_k = action.payload) === null || _k === void 0 ? void 0 : _k.highlightedIndex) !== null && _l !== void 0 ? _l : -1)
                            : -1, selectedItems: getNewList(state.selectedItems, action.payload.items, (_o = (_m = action.payload) === null || _m === void 0 ? void 0 : _m.actionType) !== null && _o !== void 0 ? _o : 'selected', isEqual), listToRender: listToRender, inputValue: '', noMatch: noMatch });
                }
                return state;
            case 'InputKeyDownArrowDown':
            case 'InputKeyDownArrowUp': {
                var focusedElement = document.activeElement;
                if ((focusedElement === null || focusedElement === void 0 ? void 0 : focusedElement.getAttribute('role')) === 'combobox') {
                    return __assign(__assign({}, state), { isExpanded: true, highlightedIndex: (_q = (_p = action.payload) === null || _p === void 0 ? void 0 : _p.highlightedIndex) !== null && _q !== void 0 ? _q : -1 });
                }
                return state;
            }
            case 'FocusMovedOutSide': {
                return __assign(__assign({}, state), { isExpanded: false, highlightedIndex: -1, inputValue: '' });
            }
            case 'DropdownListPropUpdated': {
                return __assign(__assign({}, state), getListToRender({
                    inputValue: state.inputValue,
                    searchAttributes: searchAttributes,
                    maxRenderedDropdownElements: maxRenderedDropdownElements,
                    dropdownList: dropdownList,
                    noMatchDropdownList: noMatchDropdownList,
                    searchMatcher: searchMatcher,
                    showAllItemsInDropdown: ((_r = state.inputValue) === null || _r === void 0 ? void 0 : _r.trim().length) === 0,
                }));
            }
            default:
                return state;
        }
    };
};
